import React from 'react';

const EventSwitcherItem = (props) => {
    return <li className='event' onClick={(e) => { e.stopPropagation(); props.onClick(props.id) }}>
        { props.title }
    </li>;
};

export default EventSwitcherItem;